var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCompany = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3091 12.1617H14.64V13.4926H0V12.1617H1.33091V0.848926C1.33091 0.672437 1.40102 0.503176 1.52582 0.378379C1.65061 0.253582 1.81987 0.183472 1.99636 0.183472H12.6436C12.8201 0.183472 12.9894 0.253582 13.1142 0.378379C13.239 0.503176 13.3091 0.672437 13.3091 0.848926V12.1617ZM11.9782 12.1617V1.51438H2.66182V12.1617H11.9782ZM4.65818 6.17256H6.65455V7.50347H4.65818V6.17256ZM4.65818 3.51074H6.65455V4.84165H4.65818V3.51074ZM4.65818 8.83438H6.65455V10.1653H4.65818V8.83438ZM7.98545 8.83438H9.98182V10.1653H7.98545V8.83438ZM7.98545 6.17256H9.98182V7.50347H7.98545V6.17256ZM7.98545 3.51074H9.98182V4.84165H7.98545V3.51074Z",
    fill: "#495057"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompany, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Company.54f90334.svg";
export { ForwardRef as ReactComponent };